import { UnitOfMeasure, UomType } from '@bechtel/types';
import { AppUser } from '~/components';
import { UNIT_OF_MEASURE } from '~/types';

export const checkIfUnitOfMeasureIsHours = (user: AppUser) => {
  return user?.userPreference?.unitOfMeasure
    ? user.userPreference?.unitOfMeasure?.toUpperCase() === UnitOfMeasure.HOURS
    : true;
};

export const getUnitOfMeasure = (user: AppUser) => {
  const unitOfMeasure = user?.project?.uomType?.toUpperCase();
  if (unitOfMeasure === UomType.METRIC) {
    return UNIT_OF_MEASURE.LINEAR_METERS;
  } else {
    return UNIT_OF_MEASURE.LINEAR_FEET;
  }
};

export const formatUnitLabel = (unitOfMeasure: UNIT_OF_MEASURE, abbreviated: boolean = false): string => {
  if (abbreviated) {
    switch (unitOfMeasure) {
      case UNIT_OF_MEASURE.HOUR:
        return 'hrs';
      case UNIT_OF_MEASURE.LINEAR_FEET:
        return 'LF';
      case UNIT_OF_MEASURE.LINEAR_METERS:
        return 'LM';
      default:
        return 'hrs';
    }
  } else {
    switch (unitOfMeasure) {
      case UNIT_OF_MEASURE.HOUR:
        return 'hours';
      case UNIT_OF_MEASURE.LINEAR_FEET:
        return 'Linear Feet';
      case UNIT_OF_MEASURE.LINEAR_METERS:
        return 'Linear Meters';
      default:
        return 'hours';
    }
  }
};

/**
 * Gets the formatted unit label based on user's unit preference.
 * Combines getUnitOfMeasure and formatUnitLabel for convenience.
 *
 * @param user - The user object containing preferences
 * @param abbreviated - If true, returns abbreviated form (hrs, LF, LM). Default is false
 * @returns Formatted unit label string
 *
 * @example
 * // Full format
 * getUserUnitLabel(user) → 'hours' | 'Linear Feet' | 'Linear Meters'
 *
 * // Abbreviated format
 * getUserUnitLabel(user, true) → 'hrs' | 'LF' | 'LM'
 */
export const getUserUnitLabel = (user: AppUser, abbreviated: boolean = false): string => {
  const unitOfMeasure = getUnitOfMeasure(user);
  return formatUnitLabel(unitOfMeasure, abbreviated);
};
